<p-dialog
  #wlConfirmSafeguardDialog
  modal="true" [(visible)]="showModal"
  [closable]="true"
  styleClass="atlas-dialog-m"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '75vh' }"
>
  <ng-template pTemplate="header">
    <h4 class="modal-title text-center">{{ titleText | uppercase }}</h4>
  </ng-template>

  <p class="text-center">
    {{ messageText }}
    <br />
    <br />
    <input type="checkbox" [(ngModel)]="selectedYes" (ngModelChange)="yesChanged($event)" />{{ 'common.yes' | translate | titlecase }}
    &nbsp;
    <input type="checkbox" [(ngModel)]="selectedNo" (ngModelChange)="noChanged($event)" />{{ 'common.no' | translate | titlecase }}
  </p>
  <ng-template pTemplate="footer">
    <div>
      <div class="row">
        <div class="col-xs-11">
          <div>
            <button pButton type="button" class="btn btn-primary" [disabled]="!selectedYes" (click)="dialogYes()">{{ yesText | titlecase }}</button>
            <button pButton type="button" class="atlas-btn atlas-btn-default" (click)="dialogNo()">{{ noText | titlecase }}</button>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</p-dialog>
